export const FETCH_SUCCESS = "CUSTOMER_GROUPS/FETCH_SUCCESS";
export const TABLE_UPDATE = "CUSTOMER_GROUPS/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "CUSTOMER_GROUPS/DESTROY_FAILED",
    DESTROY_REQUEST: "CUSTOMER_GROUPS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "CUSTOMER_GROUPS/DESTROY_SUCCESS",

    FETCH_FAILED: "CUSTOMER_GROUPS/FETCH_FAILED",
    FETCH_REQUEST: "CUSTOMER_GROUPS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "CUSTOMER_GROUPS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "CUSTOMER_GROUPS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "CUSTOMER_GROUPS/FETCH_ALL_SUCCESS",

    GET_FAILED: "CUSTOMER_GROUPS/GET_FAILED",
    GET_REQUEST: "CUSTOMER_GROUPS/GET_REQUEST",
    GET_SUCCESS: "CUSTOMER_GROUPS/GET_SUCCESS",

    STORE_FAILED: "CUSTOMER_GROUPS/STORE_FAILED",
    STORE_REQUEST: "CUSTOMER_GROUPS/STORE_REQUEST",
    STORE_SUCCESS: "CUSTOMER_GROUPS/STORE_SUCCESS",

    UPDATE_FAILED: "CUSTOMER_GROUPS/UPDATE_FAILED",
    UPDATE_REQUEST: "CUSTOMER_GROUPS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "CUSTOMER_GROUPS/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
